export default __webpack_public_path__ + "static/media/analytics_infected.d21fd21c.svg";